export const CALCULATOR_SERVICE = {
    getDaysOfCanRelease,
    getRecommendPurchaseQty,
    getAlreadyPurchasedQtyList
}

function getDaysOfCanRelease({ stockQty, releaseQtyPerDay }) {
    if (stockQty <= 0 || releaseQtyPerDay <= 0) {
        return 0;
    }
    return Math.floor(stockQty / releaseQtyPerDay);
}

function getRecommendPurchaseQty({
    stockQty,
    releaseQtyPerDay,
    targetDOS,
    daysOfLeadTime,
    safetyStockQty,
    totalAlreadyPurchasedQty = 0
}) {
    let newStockQty = stockQty;
    let newReleaseQtyPerDay = releaseQtyPerDay;
    if (stockQty <= 0) {
        newStockQty = 0;
    }
    if (releaseQtyPerDay <= 0) {
        newReleaseQtyPerDay = 0;
    }

    let recommendPurchaseQty = ((Number(targetDOS) + Number(daysOfLeadTime)) * Number(newReleaseQtyPerDay)) - Number(newStockQty) - Number(totalAlreadyPurchasedQty);

    if (safetyStockQty > stockQty) {
        recommendPurchaseQty += Number(safetyStockQty) - Number(stockQty);
    }

    return recommendPurchaseQty > 0 ? recommendPurchaseQty.toFixed(2) : 0;
}

function getAlreadyPurchasedQtyList(sheetItemList) {
    if (!sheetItemList || !Array.isArray(sheetItemList)) {
        return [];
    }

    const sheetWithSummedArray = sheetItemList.map(sheet => {
        if (!sheet?.itemList || sheet?.itemList?.length === 0) {
            return {
                sheetName: sheet?.sheetName,
                summedArray: []
            };
        }
        const summedData = sheet?.itemList?.reduce((acc, item) => {
            const code = item?.optionCode;
            if (!acc[code]) {
                acc[code] = 0;
            }
            acc[code] += Number(item.quantity);
            return acc;
        }, {});

        const summedArray = Object.entries(summedData).map(([optionCode, quantity]) => ({
            optionCode,
            quantity,
        }));

        return {
            sheetName: sheet?.sheetName,
            summedArray: summedArray
        };
    })

    return sheetWithSummedArray;
}